import { render, staticRenderFns } from "./comp_VariantsSelector.vue?vue&type=template&id=4445cc5c&scoped=true&"
import script from "./comp_VariantsSelector.vue?vue&type=script&lang=js&"
export * from "./comp_VariantsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445cc5c",
  null
  
)

export default component.exports